import * as localstorage from 'modules/localstorage';

export const isAndroidTWAContext = () => {
    return localstorage.getItem(localstorage.IS_ANDROID_TWA) === localstorage.LOCAL_STORAGE_TRUE;
};
